import React from 'react'
import { Box, Text } from 'grommet'
import { Sync, View } from 'grommet-icons'
import TooltipButton from '../Button/TooltipButton'
import { displayModifyTitleModal } from '../../redux/modal/actions'
import { useDispatch } from 'react-redux'

const HideShuffleTitleButton = ({ setHiding, shuffle }) => {
  const dispatch = useDispatch()
  const openTitleModal = () => {
    dispatch(displayModifyTitleModal(true))
  }
  return (
    <Box
      direction="row"
      gap=".5rem"
      alignSelf="center"
      // margin={{ top: '2rem' }}
    >
      <TooltipButton
        icon={<View color="iconDarkLight" />}
        clicked={() => {
          setHiding(true)
        }}
        message="Hide"
        position="top"
        color=""
        padding=".8rem"
      />
      <TooltipButton
        icon={<Sync color="iconDarkLight" size="22px" />}
        clicked={shuffle}
        message="Shuffle"
        position="right"
        padding=".9rem"
        // color="secondary"
      />
      <TooltipButton
        icon={
          <Box width="1.8rem" height="1.8rem" align="center" justify="center">
            <Text color="secondary" size="1.8rem">
              T
            </Text>
          </Box>
        }
        clicked={openTitleModal}
        message="Modify Title & Desc."
        position="right"
        color="secondary"
      />
    </Box>
  )
}

export default HideShuffleTitleButton
